<template>
  <b-modal
    v-model="showModal"
    ref='modal'
    size="lg"
    :style="{ zIndex: 200 }"
    static
  >
    <template v-slot:modal-header>
      <h5 class="modal-title">Column description</h5>
      <button
        type="button"
        aria-label="Close"
        class="close"
        @click.prevent="close"
      >
          <span class="material-icons">
            close
          </span>
      </button>
    </template>
    <div>
      <div v-for="item in description" :key="item">
        <div v-html="item"></div>
      </div>
    </div>
    <template v-slot:modal-footer>
      <b-button
        variant="primary"
        class="button"
        @click.prevent="close"
      >
        Close
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    description: {
      type: Array,
      default: () => []
    },
    id: {
      type: String,
      default: ''
    }
  },
  computed: {
    showModal: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    close () {
      this.showModal = false
    }
  }
}
</script>
